import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledFormControlLabel, StyledRadioButton, StyledRadioIcon, StyledRadioCheckedIcon } from './Radio.styles.js';
const _excluded = ["label", "controlStyle"];
function Radio(_ref) {
  let {
      label,
      controlStyle
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(StyledFormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(StyledRadioButton, _extends({}, otherProps, {
      icon: /*#__PURE__*/React__default.createElement(StyledRadioIcon, null),
      checkedIcon: /*#__PURE__*/React__default.createElement(StyledRadioCheckedIcon, null)
    })),
    label: label,
    sx: controlStyle
  });
}
Radio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  controlStyle: PropTypes.shape({})
};
Radio.defaultProps = {
  label: null,
  controlStyle: {}
};
export { Radio as default };